/* eslint-disable operator-assignment*/
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
//
import BoxPlot from 'components/visuals/box-plot/box-plot';
import { ISummaryProduct, ILineGraphItem } from 'store/deal-evaluation/types';
import { EDisplay } from 'components/deal-results/product-items';
import { Control, ControlGroup, Controls, NoDataContainer } from 'components/visuals/_common';
import MultiToggleButton from 'components/buttons/multi-toggle';
import { getActiveIndexForMultiToggleButton } from 'components/deal-results/product-items/helpers';
import lineColors from 'components/visuals/multi-line-graph/colors';
import { generateLegendText } from 'lib/helpers/visuals';

const Container = styled.div``;
const labelConst = 2;

export interface IBoxPlotContainerProps {
  productSummary: ISummaryProduct;
  periodStart: Date;
  periodEnd: Date;
  pricePerUnitLabel: string;
  dealName: string;
  selectedForecastLabel: string;
  selectedCostLabel: string;
  productItemId: string;
}

const BoxPlotContainer = ({
  productSummary,
  periodEnd,
  periodStart,
  pricePerUnitLabel,
  dealName,
  selectedForecastLabel,
  selectedCostLabel,
  productItemId,
}: IBoxPlotContainerProps) => {
  const [display, setDisplay] = useState(EDisplay.NETBACK);
  const [lineGraphItems, setLineGraphItems] = useState<ILineGraphItem[]>([]);

  // Initialize the line graph items
  useEffect(() => {
    const lineGraphItemsNew: ILineGraphItem[] = [];
    let colorIndex = 0;

    // Contract
    lineGraphItemsNew.push({
      label: 'Contract',
      active: true,
      color: lineColors[colorIndex],
      priceSummary: productSummary.contract,
    });

    colorIndex = colorIndex + 1;

    // Contract w/o options
    lineGraphItemsNew.push({
      label: 'Contract w/o Options',
      active: true,
      color: lineColors[colorIndex],
      priceSummary: productSummary.withoutOpts ?? productSummary.contract,
    });

    colorIndex = colorIndex + 1;

    // BATNA 1
    lineGraphItemsNew.push({
      label: 'BATNA',
      active: true,
      color: lineColors[colorIndex],
      priceSummary: productSummary.mainBatna,
    });

    colorIndex = colorIndex + 1;

    // Other BATNAs
    if (productSummary.otherBatnas.length) {
      productSummary.otherBatnas.forEach((otherBatna, index) => {
        lineGraphItemsNew.push({
          label: `BATNA ${index + labelConst}`,
          active: true,
          color: lineColors[colorIndex],
          priceSummary: otherBatna,
        });
        colorIndex = colorIndex + 1;
      });
    }

    setLineGraphItems(lineGraphItemsNew);
  }, [productSummary]);

  // functions
  function handleDisplayChange(d: EDisplay) {
    setDisplay(d);
  }

  const multiToggleButtonOptions = [
    { text: 'Base', onClick: () => handleDisplayChange(EDisplay.BASE) },
    { text: 'Revenue', onClick: () => handleDisplayChange(EDisplay.SALES) },
    { text: 'Netback', onClick: () => handleDisplayChange(EDisplay.NETBACK) },
    { text: 'Margin', onClick: () => handleDisplayChange(EDisplay.MARGIN) },
  ];

  const boxPlotLegendText = generateLegendText({
    dealName,
    product: productSummary.name,
    selectedForecastLabel,
    selectedCostLabel,
    periodStart,
    periodEnd,
    display,
  });

  return (
    <Container>
      <Controls>
        <ControlGroup>
          <Control>
            <MultiToggleButton
              label="LINE ITEM"
              indexActive={getActiveIndexForMultiToggleButton(display)}
              options={multiToggleButtonOptions}
            />
          </Control>
        </ControlGroup>
      </Controls>
      {lineGraphItems.length ? (
        <BoxPlot
          lineGraphItems={lineGraphItems}
          legendText={boxPlotLegendText}
          selectedDisplay={display}
          pricePerUnitLabel={pricePerUnitLabel}
          productItemId={productItemId}
        />
      ) : (
        <NoDataContainer>No data</NoDataContainer>
      )}
    </Container>
  );
};

export default BoxPlotContainer;
